import http from '@/utils/http'

// 获取登录 nonce
export function getNonce(address) {
  const inviteCode = getInviteCode()
  return http.get('/auth/nonce', { params: { address, invite_code: inviteCode } })
}

// 验证签名登录
export function loginBySign(address, signature) {
  return http.post('/auth/verify', { address, signature })
}

// 获取用户信息
export function getUserProfile() {
  return http.get('/user/profile')
}

// 获取邀请信息
export function getInviteInfo() {
  return http.get('/user/invite')
}

export function getDirectTeam(params) {
  return http.get('/user/direct-team', { params })
}

// 获取试玩产品列表
export function getTrialProducts() {
  return http.get('/trial/products')
}

// 获取试玩产品详情
export function getTrialProductDetail(id) {
  return http.get(`/trial/products/${id}`)
}

// 购买试玩产品
export function buyTrialProduct(data) {
  return http.post('/trial/buy', data)
}

// 获取试玩订单
export function getTrialOrders(params) {
  return http.get('/trial/my-orders', { params })
}

// 获取正式产品列表
export function getOfficialProducts() {
  return http.get('/official/products')
}

// 获取正式产品详情
export function getOfficialProductDetail(id) {
  return http.get(`/official/products/${id}`)
}

// 购买正式产品
export function buyOfficialProduct(data) {
  return http.post('/official/buy', data)
}

// 获取正式订单
export function getOfficialOrders(params) {
  return http.get('/official/my-orders', { params })
}

export function getSiteHome() {
  return http.get('/site/home')
}

// 获取钱包信息
export function getWalletInfo() {
  return http.get('/wallet/info')
}

// 获取充值收款配置
export function getRechargeConfigs() {
  return http.get('/wallet/recharge-configs')
}

export function getWithdrawConfig() {
  return http.get('/wallet/withdraw-config')
}

// 获取自动充值配置状态
export function getWalletPaymentStatus() {
  return http.get('/wallet/payment-status')
}

// 创建钱包支付充值订单
export function createWalletPaymentOrder(data) {
  return http.post('/wallet/payment-orders', data)
}

// 查询钱包支付充值订单
export function queryWalletPaymentOrder(merchantOrderNo) {
  return http.get(`/wallet/payment-orders/${encodeURIComponent(merchantOrderNo)}`)
}

// 获取交易记录
export function getTransactions(params) {
  return http.get('/wallet/transactions', { params })
}

// 申请充值
export function applyRecharge(data) {
  return http.post('/wallet/recharge', data)
}

// 获取充值记录
export function getRechargeRecords(params) {
  return http.get('/wallet/recharges', { params })
}

// 申请提现
export function applyWithdraw(data) {
  return http.post('/wallet/withdraw', data)
}

// 获取提现记录
export function getWithdrawRecords(params) {
  return http.get('/wallet/withdrawals', { params })
}

// 上传用户图片
export function uploadUserImage(data) {
  return http.post('/upload/user-image', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

function getInviteCode() {
  const query = new URLSearchParams(window.location.search)
  const hashQuery = window.location.hash.includes('?')
    ? new URLSearchParams(window.location.hash.split('?')[1])
    : null
  return query.get('invite') || query.get('ref') || query.get('uid') ||
    (hashQuery && (hashQuery.get('invite') || hashQuery.get('ref') || hashQuery.get('uid'))) || ''
}
